import {createStore} from "redux";
import rootReducer from "./reducers";
import middleware from "./middleware";
import {Map} from "immutable";
const initialState = Map();
export const store = createStore(rootReducer,initialState,middleware);
